import React from "react";
import ReactDOM from "react-dom";
import {createStore,combineReducers,compose,applyMiddleware} from 'redux'
import { reactReduxFirebase,getFirebase } from 'react-redux-firebase'
import firebase from 'firebase'
import 'firebase/firestore'

import { reduxFirestore, firestoreReducer} from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'
import {ActionCreators} from "./reducers"

import { createMuiTheme } from '@material-ui/core/styles';
import thunk from 'redux-thunk'

import "./assets/css/material-dashboard-react.css?v=1.2.0";


import {Provider} from 'react-redux'
import Layout from "./layouts/index";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";


const isProduction = true


var firebaseStagingConfig = {
    apiKey: "AIzaSyCHyyx7sC_fSrnfwR8Xh0FL9WnOVI_5LT0",
    authDomain: "ispani-staging.firebaseapp.com",
    databaseURL: "https://ispani-staging.firebaseio.com",
    projectId: "ispani-staging",
    storageBucket: "ispani-staging.appspot.com",
    messagingSenderId: "126766794992"
};

var firebaseProductionConfig = {
    apiKey: "AIzaSyDIrSa_1_tiXDqMguTAr4g9sp6W5Il7G5U",
    authDomain: "ispani-a392c.firebaseapp.com",
    databaseURL: "https://ispani-a392c.firebaseio.com",
    projectId: "ispani-a392c",
    storageBucket: "ispani-a392c.appspot.com",
    messagingSenderId: "884034585088"
};

var firebaseConfig = isProduction?firebaseProductionConfig:firebaseStagingConfig

const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true,
    enableLogging: true,
    allowMultipleListeners: true,
    oneListenerPerPath: true,
    mergeOrdered:false
}

const theme = createMuiTheme({
    palette:{
        primary: {main:"#fc824e",contrastText:"#ffffff"},
        secondary:{main:"rgba(0, 0, 0, 0.54)",contrastText:"rgba(0, 0, 0, 0.35)"},
        success:{main:"#4CAF50",contrastText:"#4CAF50"},
        warning:{main:"#FF9900",contrastText:"#FF9900"},
        info:{main:"#ffffff",contrastText:"#ffffff"}
    }
})

firebase.initializeApp(firebaseConfig)

const firestore = firebase.firestore();
const settings = {
    timestampsInSnapshots: true};
firestore.settings(settings);

const createStoreWithFirebase = compose(
    reactReduxFirebase(firebase, rrfConfig),
    applyMiddleware(
      thunk.withExtraArgument(getFirebase)
    ),
    reduxFirestore(firebase,rrfConfig))(createStore)
const store = createStoreWithFirebase(
    combineReducers(
        {
            firebase:firebaseReducer,
            firestore:firestoreReducer,
            ...ActionCreators
        }),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)


ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider theme={theme}>
            <Layout/>
        </MuiThemeProvider>
    </Provider>,
    
  document.getElementById("root"),
);



// WEBPACK FOOTER //
// ./src/index.js